function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "music"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.067 2.921c-.593-.501-1.396-.713-2.204-.579l-8.055 1.343c-1.575.262-2.808 1.718-2.808 3.315v7.557c-.591-.345-1.268-.557-2-.557-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4v-7.153l10-1.667v5.376c-.591-.344-1.269-.556-2-.556-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4v-13c0-.819-.34-1.577-.933-2.079zm-15.067 17.079c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm4-11.181v-1.819c0-.614.531-1.241 1.137-1.342l8.054-1.343c.231-.038.437.008.583.132.146.123.226.32.226.553v2.153zm8 11.181c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
}));

var Svg064Musicnote = function Svg064Musicnote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg064Musicnote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/064-music note.b313fc36.svg";
export { ForwardRef as ReactComponent };